export const consignmentIntegers = [];
export const consignmentFloats = [];
export const consignmentIsoStrings = ['estimatedDeliveryAt'];
export const consignmentWhiteList = [
  'id',
  // name is not included as it is constructed on the Model in server
  'siteId',
  'supplierId',
  // 'containerIdentifier', is not included as it is a hash of the consignment item refs
  'shipmentNumber',
  'containerReference',
  'containerNumber',
  'containerSealNumber',
  'estimatedDeliveryAt',
];

export const consignmentOptimisticList = [
  ...consignmentWhiteList,
  'name', // virtual attribute
  'site',
  'supplier',
  'consignmentItems',
  'consignmentImages',
];
